const slider = document.querySelector("[data-showcase-slider]");
const prevButton = document.querySelector("[data-showcase-prev-butt]");
const nextButton = document.querySelector("[data-showcase-next-butt]");
const scrollLeft = document.querySelector("[data-showcase-scroll-left]");
const scrollRight = document.querySelector("[data-showcase-scroll-right]");

const sliderScrollableWidth = slider.scrollWidth - slider.clientWidth;

slider.addEventListener("scroll", ()=> {
  if (slider.scrollLeft != 0) {
    if (prevButton) {
      prevButton.style["opacity"] = "100%";
    }
    if (scrollLeft) {
      scrollLeft.style["opacity"] = "100%";
    }
  } else {
    if (prevButton) {
      prevButton.style["opacity"] = "0%";
    }
    if (scrollLeft) {
      scrollLeft.style["opacity"] = "0%";
    }
  }

  if (slider.scrollLeft >= sliderScrollableWidth) {
    if (nextButton) {
      nextButton.style["opacity"] = "0%";
    }
    if (scrollRight) {
      scrollRight.style["opacity"] = "0%";
    }
  } else {
    if (nextButton) {
      nextButton.style["opacity"] = "100%";
    }
    if (scrollRight) {
      scrollRight.style["opacity"] = "100%";
    }
  }

  // console.log("Scrol Left: " + slider.scrollLeft);
  // console.log("Scrollable: " + sliderScrollableWidth)

})
